<template>
  <ai-expandable-chip
    v-if="inclusiveness.level !== AllInclusivePlan.None"
    :light="optional"
    icon-left="all"
    icon-right="info">
    <template #label>{{ $t('allInclusiveTag.label') }}</template>

    <template v-if="optional" #right>
      <ai-typo
        as="span"
        variant="paragraph-03-regular"
        class="AllInclusiveTag-optionalLabel">
        {{ $t('allInclusiveTag.optional') }}
      </ai-typo>
    </template>

    <template v-if="!optional" #menu>
      <ul>
        <li v-for="item in items" :key="item" class="AllInclusiveTag-menuItem">
          <ai-icon
            name="check"
            :size="16"
            class="AllInclusiveTag-menuItem-icon" />
          <ai-typo
            as="span"
            variant="paragraph-04-regular"
            class="AllInclusiveTag-menuItem-text">
            {{ item }}
          </ai-typo>
        </li>
      </ul>
    </template>
  </ai-expandable-chip>
</template>

<script setup lang="ts">
import { AllInclusivePlan } from '../../constants';
import { type Inclusiveness } from '../../interfaces';

type Props = {
  inclusiveness?: Inclusiveness;
};

const props = withDefaults(defineProps<Props>(), {
  inclusiveness: () => ({
    level: AllInclusivePlan.None,
    optional: false,
  }),
});

const optional = computed(() => props.inclusiveness.optional);

const { t } = useI18n();

const fullItems = computed(() => [
  t('allInclusiveTag.items.restaurantsAndBars'),
  t('allInclusiveTag.items.kidsClub'),
  t('allInclusiveTag.items.sportsAndActivities'),
  t('allInclusiveTag.items.entertainments'),
  t('allInclusiveTag.items.spa'),
]);

const partialItems = computed(() => [
  t('allInclusiveTag.items.restaurantsAndBars'),
  t('allInclusiveTag.items.sportsAndActivities'),
  t('allInclusiveTag.items.entertainments'),
  t('allInclusiveTag.items.spa'),
]);

const items = computed(() =>
  props.inclusiveness.level === AllInclusivePlan.Full
    ? fullItems.value
    : partialItems.value,
);
</script>

<style scoped lang="scss">
@use '@/assets/styles/utilities/constants';

.AllInclusiveTag-optionalLabel {
  margin-left: constants.$inner-01;
}

.AllInclusiveTag-menuItem {
  color: white;
  display: flex;
  flex-direction: row;
  align-items: flex-start;
}

.AllInclusiveTag-menuItem-icon {
  margin-top: constants.$inner-01;
  margin-right: constants.$inner-02;
  margin-bottom: constants.$inner-02;
  color: white;
  fill: white;
}

.AllInclusiveTag-menuItem-text {
  color: white;
}
</style>
